const config = {
  apiGateway: {
    URL: "https://ia3f2mam1e.execute-api.ca-central-1.amazonaws.com/v1/",
    AUTH: "https://va0vw30wa4.execute-api.ca-central-1.amazonaws.com/v1/",
    REGION: "ca-central-1"
  },
  defaultLanguage: "en",
  sso_enabled: true,
  sso_config: {
            auth_url: "acpi-prod.auth.ca-central-1.amazoncognito.com",
            identity_provider: "ACPI-PROD-AD",
            scope: "openid+aws.cognito.signin.user.admin",
            grant_type: "authorization_code",
            client_id: "3tevvp5ln0libp2rnt2ivfc62t",
            redirect_uri: "https://aligned360.aligned.digital/authorize",
        },
  dast_config: {enabled: false},
  canadaPostApiKey: "KH64-TE21-CE54-XE52",
  fef_ui_version: "2.0.63.1-tier2"
}

var siteConfig = {
  title: "ACPI Prod",
  fourlyticsId: false,
  fourlyticsScreenRecording: false
};

var componentConfig = {
  
};

export {config, siteConfig, componentConfig}
